<template>
  <div
    :class="{
      'form-group--error' : errors.has(name),
      'form-group--required': isRequired
    }"
    class="form-group">
    <label
      :for="name"
      class="label">{{ label }}</label>
    <textarea
      :id="name"
      v-model="model"
      v-validate="getRules"
      :name="name"
      type="text"
      :placeholder="placeholder"
      rows="3"
      :data-vv-as="label"
      class="textarea u-border-radius"/>

    <span
      v-if="showCounter"
      class="help-text">{{ charCount }} / {{ maxCount }}</span>

    <span
      v-if="errors.has(name) && showError"
      class="help-text">{{ errors.first(name) }}</span>
  </div>
</template>

<script>
import FormUtilities from './FormUtilities'

export default {
  mixins: [FormUtilities]
}
</script>
